/**
 * React Query hook for the tenant's extranet ERP registries (one per VEOS
 * environment). Feeds the non-production banner of the chrome. Fetched once
 * per session; a failure must not retry-loop behind the chrome either — the
 * banner simply stays hidden.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import {
  erpRegistriesService,
  type ExtranetErpRegistry,
} from '../api/erpRegistriesService';

/** Query key for the tenant's extranet ERP registries. */
export const EXTRANET_ERP_REGISTRIES_QUERY_KEY = ['extranet', 'erp-registries'] as const;

export function useExtranetErpRegistries(): UseQueryResult<ExtranetErpRegistry[]> {
  return useQuery<ExtranetErpRegistry[]>({
    queryKey: EXTRANET_ERP_REGISTRIES_QUERY_KEY,
    queryFn: () => erpRegistriesService.fetchAll(),
    staleTime: Infinity,
    retry: false,
  });
}
